import { CascadeMultiplierSpine } from 'core/display/spines/CascadeMultiplierSpine'

export default class makeCascadeMultiplierSpine extends PIXI.Container{
  constructor(data) {
    super()
    this.addChild(new CascadeMultiplierSpine(data))
  }
}
